import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PseiNgCustomModule } from '../psei-ng-custom.module';
import { PseicFormCheckboxComponent } from './pseic-form-checkbox/pseic-form-checkbox.component';
import { PseicFormFieldErrorsComponent } from './pseic-form-field-errors/pseic-form-field-errors.component';
import { PseicFormFieldComponent } from './pseic-form-field/pseic-form-field.component';



@NgModule({
  declarations: [PseicFormFieldComponent, PseicFormCheckboxComponent, PseicFormFieldErrorsComponent],
    imports: [
        CommonModule,
        PseiNgCustomModule,
        ReactiveFormsModule,
    ],

    exports: [PseicFormFieldComponent, PseicFormCheckboxComponent, PseicFormFieldErrorsComponent]
})
export class PseicFormFieldModule { }
